import { Component, OnInit, Input, ChangeDetectorRef, HostListener} from '@angular/core';
import { EmitButtonComponent } from '@Common/button/emit-button/emit-button.component';

@Component({
standalone: false,
  selector: 'submit-button',
  templateUrl: './submit-button.component.html',
  styleUrls: ['./submit-button.component.css']
})
export class SubmitButtonComponent extends EmitButtonComponent implements OnInit {
  constructor (private cdr: ChangeDetectorRef) {
    super ();
  }
    @HostListener('document:keydown.enter', ['$event'])
    onEnterKeydown(event: KeyboardEvent) {
        this.onClick.emit(event);
    }
  @Input () set text (t) {
    this._text = t;
    this.cdr.markForCheck();
  }
  _text = "Submit";
  ngOnInit() {
  }
  getText () {
    return this._text;
  }

}
